import React from 'react';
import {useState, useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import arrow from '../Assests/Group 2 (1).png';
import arr from '../Assests/Group 2.png';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
      const templateParams = {
        form_name: formData.name,
        form_email: formData.email,
        to_name:'Siri Chandhana',
        message: formData.message,
        email_id: formData.email,
      };

    emailjs.send('service_ypwkiio', 'template_95shejp', templateParams ,'Csvc19K_mNOhmFB_1')
      .then((result) => {
        toast.success('Email sent successfully:', result.text);
        setFormData({
          name: '',
          email: '',
          message: '',
        });
      })
      .catch((error) => {
        toast.error('Error sending email:', error.text);
      });
  };


  return (
    <div className='bg-[#242424] font-inria text-white overflow-x-hidden mt-20 '>
      <div className='grid grid-cols-1 lg:grid-cols-2 overflow-x-hidden'>
        <section className='mt-0 md:mt-20' data-aos='fade-right'>
          <div className='mr-10 ml-10 md:mr-0'>
            <h1 className='text-white text-4xl text-center'>Ready to transform your business?</h1>
          </div>
          <div className='ml-[180px] mt-2 md:ml-[400px] lg:ml-[350px] '>
            <img src={arrow} alt='arrow' />
          </div>
          <div>
            <div className=''>
              <h1 className='text-white text-4xl mt-2 text-center'>Let's work together</h1>
            </div>
            <div className='flex gap-4 mt-10 mx-10 md:ml-64 lg:ml-56 md:mr-0'>
              <a href='https://github.com/SiriChandhana06' target='_blank' data-aos="flip-down"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="white" d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34c-.46-1.16-1.11-1.47-1.11-1.47c-.91-.62.07-.6.07-.6c1 .07 1.53 1.03 1.53 1.03c.87 1.52 2.34 1.07 2.91.83c.09-.65.35-1.09.63-1.34c-2.22-.25-4.55-1.11-4.55-4.92c0-1.11.38-2 1.03-2.71c-.1-.25-.45-1.29.1-2.64c0 0 .84-.27 2.75 1.02c.79-.22 1.65-.33 2.5-.33s1.71.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02c.55 1.35.2 2.39.1 2.64c.65.71 1.03 1.6 1.03 2.71c0 3.82-2.34 4.66-4.57 4.91c.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2" /></svg></a>
              <a href='https://twitter.com/SiriChandhana_6' target='_blank' data-aos="flip-down"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 16 16"><path fill="white" d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07l-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" /></svg></a>
              <a href='http://discordapp.com/users/1165239591540895815' target='_blank' data-aos="flip-down"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="white" d="M19.27 5.33C17.94 4.71 16.5 4.26 15 4a.09.09 0 0 0-.07.03c-.18.33-.39.76-.53 1.09a16.09 16.09 0 0 0-4.8 0c-.14-.34-.35-.76-.54-1.09c-.01-.02-.04-.03-.07-.03c-1.5.26-2.93.71-4.27 1.33c-.01 0-.02.01-.03.02c-2.72 4.07-3.47 8.03-3.1 11.95c0 .02.01.04.03.05c1.8 1.32 3.53 2.12 5.24 2.65c.03.01.06 0 .07-.02c.4-.55.76-1.13 1.07-1.74c.02-.04 0-.08-.04-.09c-.57-.22-1.11-.48-1.64-.78c-.04-.02-.04-.08-.01-.11c.11-.08.22-.17.33-.25c.02-.02.05-.02.07-.01c3.44 1.57 7.15 1.57 10.55 0c.02-.01.05-.01.07.01c.11.09.22.17.33.26c.04.03.04.09-.01.11c-.52.31-1.07.56-1.64.78c-.04.01-.05.06-.04.09c.32.61.68 1.19 1.07 1.74c.03.01.06.02.09.01c1.72-.53 3.45-1.33 5.25-2.65c.02-.01.03-.03.03-.05c.44-4.53-.73-8.46-3.1-11.95c-.01-.01-.02-.02-.04-.02M8.52 14.91c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.84 2.12-1.89 2.12m6.97 0c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.83 2.12-1.89 2.12" /></svg></a>
              <a href='https://www.linkedin.com/in/siri-chandhana-k-06s11s2003' target='_blank' data-aos="flip-down"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><g fill="none"><path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" /><path fill="white" d="M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm0 2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1M8 10a1 1 0 0 1 .993.883L9 11v5a1 1 0 0 1-1.993.117L7 16v-5a1 1 0 0 1 1-1m3-1a1 1 0 0 1 .984.821a6 6 0 0 1 .623-.313c.667-.285 1.666-.442 2.568-.159c.473.15.948.43 1.3.907c.315.425.485.942.519 1.523L17 12v4a1 1 0 0 1-1.993.117L15 16v-4c0-.33-.08-.484-.132-.555a.55.55 0 0 0-.293-.188c-.348-.11-.849-.052-1.182.09c-.5.214-.958.55-1.27.861L12 12.34V16a1 1 0 0 1-1.993.117L10 16v-6a1 1 0 0 1 1-1M8 7a1 1 0 1 1 0 2a1 1 0 0 1 0-2" /></g></svg></a>
              <a href='https://t.me/siri_chandhana_k' target='_blank' data-aos="flip-down"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="white" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19c-.14.75-.42 1-.68 1.03c-.58.05-1.02-.38-1.58-.75c-.88-.58-1.38-.94-2.23-1.5c-.99-.65-.35-1.01.22-1.59c.15-.15 2.71-2.48 2.76-2.69a.2.2 0 0 0-.05-.18c-.06-.05-.14-.03-.21-.02c-.09.02-1.49.95-4.22 2.79c-.4.27-.76.41-1.08.4c-.36-.01-1.04-.2-1.55-.37c-.63-.2-1.12-.31-1.08-.66c.02-.18.27-.36.74-.55c2.92-1.27 4.86-2.11 5.83-2.51c2.78-1.16 3.35-1.36 3.73-1.36c.08 0 .27.02.39.12c.1.08.13.19.14.27c-.01.06.01.24 0 .38" /></svg></a>
            </div>
          </div>
        </section>
        <section className='mx-10 my-10 md:ml-40 md:mr-0 '>
          <div>
            <div className='p-5 border border-gray-300 h-6/7 w-80 rounded-3xl md:w-[500px]'>
              <h1 className='capitalize font-inria text-4xl text-center font-semibold text-white'>Highlights</h1>
              <div>
                <a title='Shefi Profile' href=' https://airtable.com/appS9uWJIqnVrxshb/shr2Weksan39XstFy/tbl8OFaxtnfy5wBEy ' target='_blank' data-aos="flip-up" className='flex justify-between rounded-xl my-5 p-3 border border-gray-100 text-white transform scale-100 transition-transform duration-300 ease-in-out hover:scale-105' style={{ backgroundColor: '#313131' }}>
                  <p className=''>SheFi Cohort 10 Member</p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M17 6H7c-.6 0-1 .4-1 1s.4 1 1 1h7.6l-8.3 8.3c-.4.4-.4 1 0 1.4c.4.4 1 .4 1.4 0L16 9.4V17c0 .6.4 1 1 1s1-.4 1-1V7c0-.6-.4-1-1-1"/></svg>               
                </a>
                <a title='Siher Website' href='https://sirichandhanak.siher.eth.limo/' target='_blank' data-aos="flip-up" className='flex justify-between rounded-xl my-5 p-3 border border-gray-100 text-white transform scale-100 transition-transform duration-300 ease-in-out hover:scale-105' style={{ backgroundColor: '#313131' }}>
                  <p className=''>SiHer Co-Activator</p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M17 6H7c-.6 0-1 .4-1 1s.4 1 1 1h7.6l-8.3 8.3c-.4.4-.4 1 0 1.4c.4.4 1 .4 1.4 0L16 9.4V17c0 .6.4 1 1 1s1-.4 1-1V7c0-.6-.4-1-1-1"/></svg>
                </a>
                <a href='www.t369token.com' title='Team 369 Website' target='_blank' data-aos="flip-up" className='flex justify-between rounded-xl my-5 p-3 border border-gray-100 text-white transform scale-100 transition-transform duration-300 ease-in-out hover:scale-105' style={{ backgroundColor: '#313131' }}>
                  <p className=''>Team 369 - Jr.Blockchain Developer Member</p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M17 6H7c-.6 0-1 .4-1 1s.4 1 1 1h7.6l-8.3 8.3c-.4.4-.4 1 0 1.4c.4.4 1 .4 1.4 0L16 9.4V17c0 .6.4 1 1 1s1-.4 1-1V7c0-.6-.4-1-1-1"/></svg>
                </a>
                <a title='SSF Community Profile' href='https://ssfcommunities.beam.gg/profile/Siri-Chandhana-K-2r7cn8lg54ih7d' target='_blank' data-aos="flip-up" className='flex justify-between rounded-xl my-5 p-3 border border-gray-100 text-white transform scale-100 transition-transform duration-300 ease-in-out hover:scale-105' style={{ backgroundColor: '#313131' }}>
                  <p className=''>Shooting Star Community Member</p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M17 6H7c-.6 0-1 .4-1 1s.4 1 1 1h7.6l-8.3 8.3c-.4.4-.4 1 0 1.4c.4.4 1 .4 1.4 0L16 9.4V17c0 .6.4 1 1 1s1-.4 1-1V7c0-.6-.4-1-1-1"/></svg>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className='lg:flex'>
        <section className='lg:mt-48 lg:w-96 lg:ml-40' data-aos="fade-right">
          <div className=''>
            <h1 className='text-white text-7xl font-semibold text-center'>Ping me</h1>
          </div>
          <div className='flex justify-center mt-2'>
            <img src={arr} alt='arr' />
          </div>
        </section>
        <section data-aos="fade-left">
          <div>
            <div className="my-10 mx-10">
              <form onSubmit={handleSubmit} className=" p-8 rounded-lg shadow-lg border border-[#E4B379] shadow-[#E4B379] w-full lg:w-[800px]">
                <div className="mb-4">
                  <label className="block text-white text-md font-bold mb-2 md:text-xl" htmlFor="name">
                    Name
                  </label>
                  <input
                    className="w-full px-3 py-2 text-white bg-[#242424] border-b border-gray-500 focus:outline-none focus:border-yellow-500"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-white text-md font-bold mb-2 md:text-xl" htmlFor="email">
                    Email
                  </label>
                  <input
                    className="w-full px-3 py-2 text-white bg-[#242424] border-b border-gray-500 focus:outline-none focus:border-[#E4B379] "
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange} 
                    required
                  />
                </div>
                <div className="mb-6">
                  <label className="block text-white text-md font-bold mb-2 md:text-xl" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    className="w-full px-3 text-white bg-[#242424] border-b border-gray-500 focus:outline-none focus:border-[#E4B379]"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <div className="">
                  <button
                    className="px-10 py-2 font-semibold text-white border-2 border-[#E4B379] shadow-md shadow-[#E4B379] rounded-full hover:bg-[#E4B379] hover:text-black hover:shadow-transparent focus:outline-none"
                    type="submit"
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    theme="colored" />
    </div>
  )
}

export default Contact;
